export enum CalculationTypeEnum {
  rentOnly = 'RENT ONLY',
  rentAndFees = 'RENT AND FEES',
};
